// Usage:
//loading('botonId').start('tex');
//loading('botonId').stop();

/* let btnLoading = loading('botonId');
btnLoading.start('tex')
btnLoading.stop();*/
class ButtonLoading {
    static start(button, text) {
        button.dataset.originalText = button.innerHTML;
        button.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> ' + text;
        button.disabled = true;
    }

    static stop(button) {
        button.innerHTML = button.dataset.originalText;
        button.disabled = false;
    }
}

class DivLoading {
    static start(renderToElement, message) {
        var mask = renderToElement.querySelector('.loading-mask');

        if (!mask) {
            var maskHTML = `
                <div class="loading-mask">
                    <div class="loading-mask-content p-4">
                        <span class="spinner-border spinner-border-sm text-success"></span>
                        <label class="loading-message"></label>
                    </div>
                </div>`;
            renderToElement.style.position = 'relative';
            renderToElement.insertAdjacentHTML('beforeend', maskHTML);
            mask = renderToElement.querySelector('.loading-mask');
        }

        mask.querySelector('.loading-message').innerHTML = message;
        mask.style.display = 'block';
    }

    static stop(renderToElement) {
        var mask = renderToElement.querySelector('.loading-mask');

        if (mask)
            mask.style.display = 'none';
    }      
}

class FormLoading {
    static start(renderToElement, message) {
        var btnSubmit = renderToElement.querySelector('button[type="submit"]');

        DivLoading.start(renderToElement, message);

        if (btnSubmit) {
            ButtonLoading.start(btnSubmit, message);
        }
    }

    static stop(renderToElement) {
        var btnSubmit = renderToElement.querySelector('button[type="submit"]');

        DivLoading.stop(renderToElement);

        if (btnSubmit) {
            ButtonLoading.stop(btnSubmit);
        }
    }
}
export default function loading(renderTo) {
    var renderToElement = (renderTo instanceof Object) ? renderTo : document.getElementById(renderTo);

    return {
        start: (text) => {
            switch (renderToElement.tagName) {
                case 'BUTTON':
                    ButtonLoading.start(renderToElement, text);
                    break;
                case 'FORM':
                    FormLoading.start(renderToElement, text);
                    break;
                case 'DIV':
                    DivLoading.start(renderToElement, text);
                    break;
                default:
                    console.error('Tipo de elemento no compatible para iniciar el efecto de carga.');
            }
        },
        stop: () => {
            switch (renderToElement.tagName) {
                case 'BUTTON':
                    ButtonLoading.stop(renderToElement);
                    break;
                case 'FORM':
                    FormLoading.stop(renderToElement);
                    break;
                case 'DIV':
                    DivLoading.stop(renderToElement);
                    break;
                default:
                    console.error('Tipo de elemento no compatible para detener el efecto de carga.');
            }
        },
        // Ref-count: varios show() anidados (grid + combo, etc.) deben equilibrarse con hide().
        // Antes: cada show() creaba un .overlay y hide() solo quitaba el primero → loading “atascado”.
        show: () => {
            if (typeof window.__loadingOverlayRefCount !== "number") {
                window.__loadingOverlayRefCount = 0;
            }
            window.__loadingOverlayRefCount++;
            if (window.__loadingOverlayRefCount !== 1) {
                return;
            }
            // Limpiar overlays huérfanos de sesiones desbalanceadas
            document.querySelectorAll("body > .overlay").forEach(function (el) {
                el.remove();
            });
            const overlay = document.createElement("div");
            overlay.className = "overlay";
            overlay.id = "app-global-loading-overlay";
            const spinner = document.createElement("div");
            spinner.className = "spinner";
            spinner.innerHTML = "<div></div>";
            overlay.appendChild(spinner);
            document.body.appendChild(overlay);
        },
        hide: () => {
            if (typeof window.__loadingOverlayRefCount !== "number") {
                window.__loadingOverlayRefCount = 0;
            }
            if (window.__loadingOverlayRefCount > 0) {
                window.__loadingOverlayRefCount--;
            }
            if (window.__loadingOverlayRefCount > 0) {
                return;
            }
            window.__loadingOverlayRefCount = 0;
            const el = document.getElementById("app-global-loading-overlay");
            if (el && el.parentNode) {
                el.parentNode.removeChild(el);
            }
            // Por si quedó algún .overlay sin id (versiones previas u otro código)
            document.querySelectorAll("body > .overlay").forEach(function (n) {
                n.remove();
            });
        }
    };
}




